import { Injectable } from "@angular/core";
import firebase from "firebase";
import { Movie } from "../data/Movie";
import { TvShow } from "../data/TvShow";
import { ComingSoon } from "../data/ComingSoon";
import { Trailer } from "../data/Trailer";
import { NotificationItem } from "../data/NotificationItem";

@Injectable()
export class UserService {
  constructor() {}

  addUser(user: firebase.User) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(user.uid)
        .set(
          {
            name: user.displayName,
            picture: user.photoURL
          },
          { merge: true }
        )
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  getIsMoviePartOfMyList(userId: string, movieId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("moviesFollowed")
        .get()
        .then(moviesFollowedSnapshot => {
          moviesFollowedSnapshot.forEach(doc => {
            if (doc.id === movieId) {
              resolve({ isPartOfMyList: true });
            }
          });

          resolve({ isPartOfMyList: false });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  addMovieToMyList(userId: string, movie: Movie) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("moviesFollowed")
        .doc(movie.movieId)
        .set(
          {
            movieId: movie.movieId,
            name: movie.name,
            picture: movie.picture
          },
          { merge: true }
        )
        .then(() => {
          resolve();
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  removeMovieFromMyList(userId: string, movieId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("moviesFollowed")
        .doc(movieId)
        .delete()
        .then(() => {
          resolve();
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  getIsTvShowPartOfMyList(userId: string, tvShowId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("tvShowsFollowed")
        .get()
        .then(tvShowsFollowedSnapshot => {
          tvShowsFollowedSnapshot.forEach(doc => {
            if (doc.id === tvShowId) {
              resolve({ isPartOfMyList: true });
            }
          });

          resolve({ isPartOfMyList: false });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  addTvShowToMyList(userId: string, tvShow: TvShow) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("tvShowsFollowed")
        .doc(tvShow.tvShowId)
        .set(
          {
            tvShowId: tvShow.tvShowId,
            name: tvShow.name,
            picture: tvShow.picture,
          },
          { merge: true }
        )
        .then(() => {
          resolve();
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  addTrailerToMyList(userId: string, trailer: Trailer) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("trailersFollowed")
        .doc(trailer.trailerId)
        .set(
          {
            trailerId: trailer.trailerId,
            name: trailer.name,
            picture: trailer.picture,
          },
          { merge: true }
        )
        .then(() => {
          resolve();
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  addComingSoonToMyList(userId: string, comingSoon: ComingSoon) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("comingSoonFollowed")
        .doc(comingSoon.comingSoonId)
        .set(
          {
            comingSoonId: comingSoon.comingSoonId,
            name: comingSoon.name,
            picture: comingSoon.picture,
          },
          { merge: true }
        )
        .then(() => {
          resolve();
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }



  removeTvShowFromMyList(userId: string, tvShowId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("tvShowsFollowed")
        .doc(tvShowId)
        .delete()
        .then(() => {
          resolve();
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  getPrivateNotifications(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("notifications")
        .get()
        .then(snapshot => {
          const notifications = [];

          snapshot.forEach(doc => {
            let notification: any = {};

            notification.id = doc.id;
            notification.title = doc.data().title;
            notification.addedAt = doc.data().addedAt;
            notification.description = doc.data().description;

            notifications.push(notification);
          });

          resolve({ notifications: notifications });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  getFavoriteMovies(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("moviesFollowed")
        .get()
        .then(moviesFollowedSnapshot => {
          const favoriteMovies = [];

          moviesFollowedSnapshot.forEach(doc => {
            const movie = new Movie();

            movie.movieId = doc.id;
            movie.name = doc.data().name;
            movie.picture = doc.data().picture;

            favoriteMovies.push(movie);
          });

          resolve({ favoriteMovies: favoriteMovies });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  getFavoriteTvShows(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("tvShowsFollowed")
        .get()
        .then(tvShowsFollowedSnapshot => {
          const favoriteTvShows = [];

          tvShowsFollowedSnapshot.forEach(doc => {
            const tvShow = new TvShow();

            tvShow.tvShowId = doc.id;
            tvShow.name = doc.data().name;
            tvShow.picture = doc.data().picture;

            favoriteTvShows.push(tvShow);
          });

          resolve({ favoriteTvShows: favoriteTvShows });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  getFavoriteTrailers(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("trailersFollowed")
        .get()
        .then(snapshot => {
          const trailers = [];

          snapshot.forEach(doc => {
            const trailer = new Trailer();

            trailer.trailerId = doc.id;
            trailer.name = doc.data().name;
            trailer.picture = doc.data().picture;

            trailers.push(trailer);
          });

          resolve({ trailers: trailers });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  getFavoriteComingSoon(userId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(userId)
        .collection("comingSoonFollowed")
        .get()
        .then(snapshot => {
          const comingSoons = [];

          snapshot.forEach(doc => {
            const comingSoon = new ComingSoon();

            comingSoon.comingSoonId = doc.id;
            comingSoon.name = doc.data().name;
            comingSoon.picture = doc.data().picture;

            comingSoons.push(comingSoon);
          });

          resolve({ comingSoons: comingSoons });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }


}



// WEBPACK FOOTER //
// ./src/services/UserService.ts